document.addEventListener('DOMContentLoaded', function () {
  // Function to calculate progress based on mouse position relative to the progress bar
  function calculateProgressFromPosition(event, progressBar) {
    const rect = progressBar.getBoundingClientRect();
    const offsetX = event.touches ? event.touches[0].clientX - rect.left : event.clientX - rect.left;
    let progress = (offsetX / rect.width) * 100;

    // Clamp progress between 0% and 100%, then round it to the nearest integer
    return Math.round(Math.min(Math.max(progress, 0), 100));
  }

  // Function to update both the circle and the progress bar together instantly
  function updateProgress(progressBar, progressCircle, progressValue, progress) {
    const roundedProgress = Math.round(progress); // Ensure progress is always an integer

    progressCircle.style.left = `${roundedProgress}%`; // Move the circle
    progressBar.style.background = `linear-gradient(to right, #fbb03b ${roundedProgress}%, #e0e0e0 ${roundedProgress}%)`; // Update the progress bar
    if (progressValue) {
      progressValue.textContent = `${roundedProgress}%`; // Update the percentage text
      progressValue.style.left = `${roundedProgress}%`; // Position the text
    }
  }

  // Function to calculate progress from input amount based on available points, clamped by max points
  function calculateProgressFromAmount(input) {
    const availablePoints = parseInt(input.getAttribute('data-points'), 10);  // Get available points
    const max = parseInt(input.getAttribute('data-max'), 10);  // Get the max allowed points
    let value = parseInt(input.value, 10);

    // If input is empty or NaN, set value to 0
    if (isNaN(value) || input.value.trim() === '') {
      value = 0;
    }

    // Handle case where both points and max are 0
    if (availablePoints === 0 && max === 0) {
      input.value = 0;  // Set the input value to 0 to avoid NaN
      return 0;  // Return 0 progress since both are 0
    }

    // Clamp value to max if it exceeds max
    if (value > max) {
      value = max;
      input.value = max;  // Update input to max if exceeded
    }

    // Clamp value to availablePoints if it exceeds availablePoints (even if under max)
    if (value > availablePoints) {
      value = availablePoints;
      input.value = availablePoints;  // Update input to availablePoints if exceeded
    }

    // Calculate progress based on available points and round it to the nearest integer
    const progress = Math.round((value / availablePoints) * 100);

    // Clamp progress between 0% and 100%
    return Math.min(Math.max(progress, 0), 100);
  }

  // Function to update the amount based on the progress (ensuring integers)
  function updateAmount(input, progress) {
    console.log(progress)
    if (!input) return;

    const availablePoints = parseInt(input.getAttribute('data-points'), 10);  // Use availablePoints
    const maxPoints = parseInt(input.getAttribute('data-max'), 10);

    // Handle case where both availablePoints and max are 0
    if (availablePoints === 0) {
      input.value = 0;  // Set the input value to 0
      return;
    }

    // Calculate the amount based on the integer progress
    const calc = Math.round(availablePoints * (progress / 100));
    const newAmount = Math.min(Math.max(0, calc), availablePoints);  // Clamp the value between 0 and availablePoints

    // Update the input field value with an integer
    inputValue = Math.round(newAmount);

    if (inputValue > maxPoints) {
      inputValue = maxPoints;
    }

    input.value = inputValue;
  }

  // Function to update all child sliders when the parent slider moves
  function updateAllChildSliders(parentProgress) {
    document.querySelectorAll('.progress-container').forEach(container => {
      const unique_id = container.getAttribute('id').replace('scroll_bar_', '');
      if (unique_id !== 'parent') {
        const progressBar = document.getElementById(`progressBar_${unique_id}`);
        const progressCircle = document.getElementById(`progressCircle_${unique_id}`);
        const progressValue = document.getElementById(`progressValue_${unique_id}`);
        const input = document.querySelector(`[name="${unique_id}_amount"]`);

        const availablePoints = parseInt(input.getAttribute('data-points'), 10);  // Child's available points
        const max = parseInt(input.getAttribute('data-max'), 10);  // Child's max points

        // Handle case where both availablePoints and max are 0
        if (availablePoints === 0 && max === 0) {
          updateProgress(progressBar, progressCircle, progressValue, 0);  // Set progress to 0%
          input.value = 0;  // Set input value to 0
          return;  // No need to update further
        }

        // Calculate the child's progress based on the parentProgress and ensure it's an integer
        let childProgress = Math.round((parentProgress / 100) * availablePoints);

        // If the child progress reaches or exceeds max points, set the input directly to max points
        if (childProgress >= max) {
          childProgress = max;
          input.value = max;  // Set input to max points
        } else {
          // Convert the clamped progress to a percentage based on availablePoints
          const progressPercentage = Math.round((childProgress / availablePoints) * 100);

          // Update the input field with the calculated integer value
          updateAmount(input, progressPercentage);
        }

        // Update the child slider's progress bar and amount
        const progressPercentage = Math.round((childProgress / availablePoints) * 100);
        updateProgress(progressBar, progressCircle, progressValue, progressPercentage);  // Update the progress bar and circle
      }
    });
  }


  // Initialize a single slider (either parent or child)
  function initSlider(unique_id, isParent = false) {
    const progressBar = document.getElementById(`progressBar_${unique_id}`);
    const progressCircle = document.getElementById(`progressCircle_${unique_id}`);
    const progressValue = document.getElementById(`progressValue_${unique_id}`);
    const input = unique_id !== 'parent' ? document.querySelector(`[name="${unique_id}_amount"]`) : null;

    if (!progressBar || !progressCircle || !progressValue) {
      console.error(`Progress bar, circle, or value element not found for unique_id: ${unique_id}`);
      return;
    }

    const availablePoints = input ? parseInt(input.getAttribute('data-points'), 10) : 100;
    const max = input ? parseInt(input.getAttribute('data-max'), 10) : 100;

    // Check if both availablePoints and max are 0, disable the slider and set it to 0%
    if (max === 0) {
      updateProgress(progressBar, progressCircle, progressValue, 0);
      progressBar.style.background = 'linear-gradient(to right, #e0e0e0 0%, #e0e0e0 100%)';
      progressCircle.style.left = '0%';
      progressValue.textContent = '0%';
      progressBar.classList.add('disabled');
      progressBar.style.pointerEvents = 'none';
      if (input) input.value = 0;
      return;
    }

    let isDragging = false;

    const startDragging = () => {
      isDragging = true;
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('touchmove', handleMouseMove);
    };

    const stopDragging = () => {
      if (isDragging) {
        isDragging = false;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('touchmove', handleMouseMove);
      }
    };

    const handleMouseMove = (event) => {
      let progress = calculateProgressFromPosition(event, progressBar);

      // Check if progress has reached or exceeded the max, and set input to max points if so
      if (progress >= (max / availablePoints) * 100) {
        progress = Math.round((max / availablePoints) * 100);
        input.value = max;  // Set input directly to max points
        showToast('Max points reached');  // Optional toast message for reaching max
      } else {
        updateAmount(input, progress);  // Update input with the calculated progress
      }

      updateProgress(progressBar, progressCircle, progressValue, progress);

      if (isParent) {
        updateAllChildSliders(progress);  // Update all child sliders if the parent slider is moved
      }
    };

    // Handle input change to update the bar based on input value
    if (input) {
      input.addEventListener('input', function () {
        const progress = calculateProgressFromAmount(input);
        updateProgress(progressBar, progressCircle, progressValue, progress);
      });
    }

    // Event listeners for dragging (mouse and touch)
    progressCircle.addEventListener('mousedown', startDragging);
    progressCircle.addEventListener('touchstart', startDragging);
    document.addEventListener('mouseup', stopDragging);
    document.addEventListener('touchend', stopDragging);

    // Clicking on the progress bar should immediately move the circle and update progress
    progressBar.addEventListener('click', (event) => {
      let progress = calculateProgressFromPosition(event, progressBar);

      if (progress >= (max / availablePoints) * 100) {
        progress = Math.round((max / availablePoints) * 100);
        input.value = max;  // Directly set input to max points
      } else {
        updateAmount(input, progress);
      }

      updateProgress(progressBar, progressCircle, progressValue, progress);
      if (isParent) {
        updateAllChildSliders(progress);
      }
    });

    // Initialize progress at 10% by default
    const initialProgress = 10;
    updateProgress(progressBar, progressCircle, progressValue, initialProgress);
    if (!isParent) {
      updateAmount(input, initialProgress);
    }
  }

  // Initialize all sliders (parent and child)
  document.querySelectorAll('.progress-container').forEach(container => {
    const unique_id = container.getAttribute('id').replace('scroll_bar_', '');
    if (unique_id === 'parent') {
      initSlider(unique_id, true); // Initialize parent slider
    } else {
      initSlider(unique_id); // Initialize each child slider
    }
  });

  // Add event listener to "all-in" button to move parent slider to 100%
  const allInButton = document.querySelector('.all-in');
  if (allInButton) {
    allInButton.addEventListener('click', function () {
      const parentProgressBar = document.getElementById('progressBar_parent');
      const parentProgressCircle = document.getElementById('progressCircle_parent');
      const parentProgressValue = document.getElementById('progressValue_parent');

      updateProgress(parentProgressBar, parentProgressCircle, parentProgressValue, 100); // Move the parent slider to 100%
      updateAllChildSliders(100);  // Optionally update child sliders as well
    });
  }
});

// Function to show the toast message
function showToast(message) {
  var toaster = document.getElementById("toaster");
  toaster.innerText = message;
  toaster.style.display = "block";
  setTimeout(function () {
    toaster.style.display = "none";
  }, 5000); // Hide after 5 seconds
}
